import { createContext, ReactNode, useContext, useState } from "react";

interface AnalysisResultContextType {
  analysisContextResult: any;
  setAnalysisContextResult: (result: any) => void;
}

const AnalysisResultContext = createContext<AnalysisResultContextType | undefined>(
  undefined
);

interface AnalysisResultProviderProps {
  children: ReactNode;
  analysisData: any;
}

export const AnalysisResultProvider: React.FC<AnalysisResultProviderProps> = ({
    children, analysisData
}) : JSX.Element => {
  const [result, setResult] = useState<any>(analysisData);
  return (
    <AnalysisResultContext.Provider value={{analysisContextResult: result, setAnalysisContextResult: setResult}}>
      {children}
    </AnalysisResultContext.Provider>
  );
}

// Hook personnalisé pour utiliser le contexte
export const useAnalysis = (): AnalysisResultContextType => {
  const context = useContext(AnalysisResultContext);

  if (!context) {
    throw new Error("useAnalysis must be used within a AnalysisResultProvider");
  }
  return context;
};
